<div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Campanhas</h4>
        <div class="d-flex align-items-center gap-2">
            <app-input [(ngModel)]="filters.q"
                       (ngModelChange)="updateSearch()"
                       placeholder="Buscar campanhas..."
                       groupIconPosition="right"
                       groupIcon="ti-search"
                       slot="search"
                       containerStyles="mb-0"/>
        </div>
    </div>

    <div class="card-body p-0">
        <app-table [tableData]="items">
            <ng-template app-table-header>
                <th scope="col"
                    appTableHeaderColumn
                    sortField="name"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                    Campanha
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    sortField="totalLeads"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                    Empresas
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    sortField="status"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                    Status
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    sortField="createdAt"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                    Criada em
                </th>
                <th scope="col" class="pe-4 text-end">Ações</th>
            </ng-template>
            <ng-template app-table-body let-campaign>
                <td class="ps-4">
                    <div>
                        <div class="fw-medium">{{ campaign.name }}</div>
                        @if (campaign.description) {
                            <small class="text-muted text-truncate d-block" style="max-width: 300px;">
                                {{ campaign.description }}
                            </small>
                        }
                    </div>
                </td>
                <td>
                    <span class="badge bg-primary-subtle text-primary">
                        {{ (campaign.totalCompanies || 0) | number }} empresas
                    </span>
                </td>
                <td>
                    <span [class]="getStatusBadgeClass(campaign.status)">
                        {{ getStatusLabel(campaign.status) }}
                    </span>
                </td>
                <td>
                    <small class="text-muted">{{ campaign.createdAt | date:'dd/MM/yyyy HH:mm' }}</small>
                </td>
                <td class="pe-4 text-end">
                    <div class="btn-group btn-group-sm">
                        <button class="btn btn-light" title="Visualizar detalhes" (click)="openCampaignDetails(campaign)">
                            <i class="ti ti-eye"></i>
                        </button>
                    </div>
                </td>
            </ng-template>
        </app-table>

        <!-- Loading overlay -->
        <app-loading-overlay [show]="isLoading"/>

        <app-empty-alert-message [show]="!isLoading && items.length === 0" containerClass="m-2"/>

        <app-pagination
                [show]="items.length > 0"
                [itemsAmount]="pagination.itemsAmount"
                [itemsPerPage]="filters.size"
                [currentPage]="currentPage"
                (onChangeItemsPerPage)="changeItemsPerPage($event)"
                (onPaginate)="paginate($event)"/>
    </div>
</div>